import { EventEmitter } from "events";
export class Switchboard {
    static register_event_type(t) {
        if (Switchboard.emitters[t])
            return;
        Switchboard.emitters[t] = null;
    }
    static get_emitter(typ) {
        if (!(typ in Switchboard.emitters))
            Switchboard.register_event_type(typ);
        let attempted_find = Switchboard.emitters[typ];
        if (attempted_find !== null)
            return attempted_find;
        let emitter = new EventEmitter();
        emitter.setMaxListeners(200);
        Switchboard.emitters[typ] = emitter;
        return emitter;
    }
    static get_receiver(typ) {
        if (!(typ in Switchboard.emitters))
            Switchboard.register_event_type(typ);
        let attempted_find = Switchboard.emitters[typ];
        if (attempted_find !== null)
            return attempted_find;
        let receiver = new EventEmitter();
        receiver.setMaxListeners(200);
        Switchboard.emitters[typ] = receiver;
        return receiver;
    }
}
Switchboard.emitters = {
    "COLOR": null,
    "CONTEXT": null,
    "INTERACTION": null,
    "SELECTION": null,
    "MOVEMENT": null,
    "BUFFER_ERR": null,
    "BASE_LAYER_CHANGED": null,
    "MAP_ZOOM_EVENT": null
};
